import { Stack, Box, Button } from '@mui/material';
import { useState, useEffect } from 'react';
import { useFormContext, useWatch } from 'react-hook-form';
import { FormattedMessage } from 'react-intl';
import ClientAutoComplete from './ClientAutoComplete';
import type { CreateVisitType } from '../../visits/entity';
import { NewClientForm } from './new-client-form';

export const ClientSelect = ({ clientId }: { clientId?: string }) => {
  const { control, resetField } = useFormContext<CreateVisitType>();
  const [isNewClient, setIsNewClient] = useState(false);

  const firstName = useWatch({ control, name: 'firstName' });
  const lastName = useWatch({ control, name: 'lastName' });
  const phone = useWatch({ control, name: 'phone' });
  useEffect(() => {
    if (!firstName && !lastName && !phone && isNewClient) {
      setIsNewClient(false);
    }
  }, [firstName, lastName, phone]);

  return (
    <>
      <Stack
        direction={isNewClient ? 'column' : 'row'}
        spacing={1}
        alignItems={isNewClient ? undefined : 'center'}
      >
        {isNewClient ? (
          <NewClientForm />
        ) : (
          <Box sx={{ flex: 9 }}>
            <ClientAutoComplete
              fieldPath="clientId"
              required
              control={control}
              defaultValue={clientId ?? undefined}
            />
          </Box>
        )}
        <Box sx={{ flex: 3 }}>
          <Button
            size="small"
            fullWidth
            sx={{ lineHeight: '18px' }}
            onClick={() => {
              setIsNewClient(prev => !prev);
              resetField('clientId');
            }}
          >
            <FormattedMessage id="addVisitForm.newClientButton" defaultMessage="Nový klient" />
          </Button>
        </Box>
      </Stack>
    </>
  );
};
